import { Color } from '@persona-id/design-tokens';
import { RotateCwDashedIcon } from '@persona-id/design-tokens/icons';
import styled, { ThemeProvider } from 'styled-components';

import Button from 'design-system/components/Button';
import { darkTheme } from 'design-system/theme';
import { BASE } from 'design-system/variables/spacing';

interface DocumentViewerRotateProps {
  rotateDocument: () => void;
}

const HeaderButtonContainer = styled('div')`
  display: flex;
  align-items: center;
`;

const HeaderStyledButton = styled(Button)<{ isShown?: boolean }>`
  background-color: ${({ isShown }) => (isShown ? Color.PrimaryWhite : Color.CoreSlate900)};
  margin: 0px ${BASE}px;
  cursor: pointer;

  svg path {
    ${({ isShown }) => isShown && `stroke: ${Color.CorePurple700};`}
  }
  // Override Button svg stroke style
  svg.pds-icon {
    path {
      ${({ isShown }) => isShown && `stroke: ${Color.CorePurple700};`}
    }

    path[stroke] {
      ${({ isShown }) => isShown && `stroke: ${Color.CorePurple700};`}
    }
  }
`;

const DocumentViewerRotate = ({ rotateDocument }: DocumentViewerRotateProps) => {
  return (
    <ThemeProvider theme={darkTheme}>
      <HeaderButtonContainer>
        <HeaderStyledButton
          data-test='document-viewer__header--rotate-button'
          id='document-viewer__header--rotate-button'
          onClick={() => {
            rotateDocument();
          }}
          width='icon'
          variant='primary'
        >
          <RotateCwDashedIcon />
        </HeaderStyledButton>
      </HeaderButtonContainer>
    </ThemeProvider>
  );
};

export default DocumentViewerRotate;
